"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EliminatedMatches = EliminatedMatches;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const next_intl_1 = require("next-intl");
const react_1 = require("react");
const client_2 = require("../client/index.js");
/** The candidates out of the current round, behind a toggle; nothing when there are none. */
function EliminatedMatches({ result }) {
    const t = (0, next_intl_1.useTranslations)("koa.components.eliminatedMatches");
    const [shown, setShown] = (0, react_1.useState)(false);
    const eliminated = result.eliminated ?? [];
    if (eliminated.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "koa:mt-4 koa:flex koa:justify-center", children: (0, jsx_runtime_1.jsx)(client_1.Button, { variant: "link", color: "neutral", size: "small", onClick: () => setShown(!shown), "aria-expanded": shown, children: shown ? t("hide") : t("show", { count: eliminated.length }) }) }), shown && ((0, jsx_runtime_1.jsx)("div", { className: "koa:mt-4 koa:grid koa:gap-4", children: eliminated.map((match) => ((0, jsx_runtime_1.jsx)(client_2.MatchCard, { ...match }, match.candidate.id))) }))] }));
}
